import {ShapeCommand} from '../commands.template';

export class FlowlineCreateCommand extends ShapeCommand {
  protected firstAction: boolean;
  protected services: any;

  constructor({data, firstAction}) {
    super(data);
    this.firstAction = firstAction;
  }

  public execute() {
    super.execute();
    this.object.flForm = this.services.diagramTypeConfigSvc.flowlineSettings().form;
    const graph = this.services.editorRegistrySvc.getGraph();

    if (this.firstAction && this.object.mxKey) {
      this.firstAction = false;

      return this.executeJson(this.object);
    }

    this.firstAction = false;

    let source = null;
    let target = null;

    if (this.object.srcId) {
      source = this.services.graphHelperSvc
        .allActivities()
        .concat(this.services.graphHelperSvc.allConnectorAndTerminators())
        .find(cell => Number(cell.id) === Number(this.object.srcId));
    }

    if (this.object.tgtId) {
      target = this.services.graphHelperSvc
        .allActivities()
        .concat(this.services.graphHelperSvc.allConnectorAndTerminators())
        .find(cell => Number(cell.id) === Number(this.object.tgtId));
    }

    graph.model.beginUpdate();
    const edge = this.services.shapeSpawnerSvc.createFlowline(this.object, true, source, target);

    edge.skipUndo = true;
    this.services.shapeSpawnerSvc.updateFlowline(this.object, edge, source, target);
    graph.addCell(edge, this.services.graphHelperSvc.flowlineParent());
    this.object.mxKey = Number(edge.id);
    this.executeJson(this.object);
    graph.model.endUpdate();

    return edge;
  }

  public reverse() {
    super.reverse();

    const graph = this.services.editorRegistrySvc.getGraph();

    // const groupUpdate = this.services.diagramUpdateSvc.group();

    const flowlineCell = this.services.graphHelperSvc
      .allFlowlines()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    // groupUpdate.add({
    //   deleteFlowline: {mxKey: Number(flowlineCell.id)}
    // });

    graph.removeCells([flowlineCell], false);

    // return groupUpdate.sendGroup();
    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteFlowline: {
        mxKey: Number(data.mxKey)
      }
    });
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      createFlowline: {
        mxKey: Number(data.mxKey),
        text: data.text,
        srcType: data.srcType,
        tgtType: data.tgtType,
        flForm: data.flForm,
        waypoints: data.waypoints,
        srcPosition: data.srcPosition,
        tgtPosition: data.tgtPosition,
        position: data.position,
        srcId: data.srcId,
        tgtId: data.tgtId
      }
    });
  }
}
